import React, { lazy, useRef, useState } from "react";

/** Common Components */
import CardSection from "../../components/ui/card/CardSection";
import CenterModal from "../../components/ui/centerModal/CenterModal";

/** Master Field Categories Page Styling */
import "./MasterFieldCategories.scss";

/** Lazily Loaded Components */
const MasterFieldCategoriesList = lazy(() =>
  import("./components/masterFieldCategoriesList/MasterFieldCategoriesList")
);
const AddEditMasterFieldCategory = lazy(() =>
  import("./components/addEditMasterFieldCategory/AddEditMasterFieldCategory")
);

const MasterFieldCategories = () => {
  const molGridRef = useRef();

  const [isEdit, setIsEdit] = useState(false);
  const [editMasterFieldCategoryData, setEditMasterFieldCategoryData] =
    useState(null);
  const [isMasterFieldCategoryModelOpen, setIsMasterFieldCategoryModelOpen] =
    useState(false);

  const handleAddMasterFieldCategoryClick = () => {
    setIsMasterFieldCategoryModelOpen(true);
    setEditMasterFieldCategoryData(null);
    setIsEdit(false);
  };

  const handleCloseModel = () => {
    setIsMasterFieldCategoryModelOpen(false);
    setEditMasterFieldCategoryData(null);
    setIsEdit(false);
  };

  const handleEditClick = (data) => {
    setIsEdit(true);
    setEditMasterFieldCategoryData(data);
    setIsMasterFieldCategoryModelOpen(true);
  };

  const handleSuccess = () => {
    handleCloseModel();
    if (molGridRef.current) {
      molGridRef.current?.refreshGrid();
    }
  };

  return (
    <>
      <div className="master-field-categories">
        <CardSection
          cardTitle={"Master Field Categories"}
          rightButton={true}
          buttonClassName={"blue-btn"}
          titleButtonClick={handleAddMasterFieldCategoryClick}
          buttonText={"ADD"}
          searchInput={false}
          isButtonVisible={true}
          isButtonLoading={""}
          isIcon={true}
          iconClass="uil:plus"
        >
          <div className="only-list-body-scroll">
            <MasterFieldCategoriesList
              ref={molGridRef}
              onEdit={handleEditClick}
            />
          </div>
        </CardSection>
      </div>
      <CenterModal
        modalTitle={
          isEdit ? `Update Master Field Category` : `Add Master Field Category`
        }
        modalSize={"w-50"}
        isOpen={isMasterFieldCategoryModelOpen}
        onClose={handleCloseModel}
        transition={"grow"}
      >
        <AddEditMasterFieldCategory
          isEdit={isEdit}
          isOpen={isMasterFieldCategoryModelOpen}
          initData={editMasterFieldCategoryData}
          onClose={handleCloseModel}
          onSuccess={handleSuccess}
        />
      </CenterModal>
    </>
  );
};

export default MasterFieldCategories;
